import {getCurrentTimestamp} from 'helpers/date-helper';

export function generateFileName(): string {
    return `players-${getCurrentTimestamp()}.csv`;
}
